import { handleAction } from 'redux-actions';
import log from 'uix/logging';
import { setStatesConfig } from './actions';
export const config = [
    handleAction(setStatesConfig, ({ states, ...config }, { payload })=>{
        let { dname, data } = payload;
        let prevcfg = states[dname] || {};
        let nextcfg = {
            ...prevcfg,
            ...data
        };
        return {
            ...config,
            states: {
                ...states,
                [dname]: nextcfg
            }
        };
    }, {
        states: {}
    })
];
